import { isEmpty } from "lodash";
import { memberDirectoryFilters } from "@/react/components/MemberDirectory/memberDirectoryFilters";
import { usePickFilters } from "@/react/components/SettingsApp/ManageMembers/TabContent/Filters/usePickFilters";
import { usePageQuery } from "@/react/components/SettingsApp/ManageMembers/TabContent/usePageQuery";
import { useFilterParams } from "@/react/components/SettingsApp/ManageMembers/useFilterParams";
import { getOrderParamFromSort } from "@/react/helpers/urlHelpers/getOrderParamFromSort";
import {
  DEFAULT_PAGE_SIZE,
  useAudienceInfiniteQuery,
} from "@/react/hooks/useAudienceInfiniteQuery";
import type { BaseFilter } from "../../../MemberFilters/types";
import { createBaseFilter } from "../../../MemberFilters/types";

export interface UseSelectMembersInfiniteQueryV2Props {
  baseFilters?: BaseFilter[];
  defaultSort?: string;
  isAdminScope?: boolean;
}

export const memberBaseFilter = [
  createBaseFilter({
    key: "member",
    value: "true",
  }),
];

export const useSelectMembersInfiniteQueryV2 = ({
  baseFilters = [],
  defaultSort,
  isAdminScope = false,
}: UseSelectMembersInfiniteQueryV2Props) => {
  const { initialPage } = usePageQuery();
  const { filters, scope, query, order: urlOrder } = useFilterParams(0);

  const order = defaultSort ? getOrderParamFromSort(defaultSort) : urlOrder;

  const pickedFilters = usePickFilters({
    allFilters: memberDirectoryFilters,
    selectedFilters: filters,
  });

  const finalFilters = [...pickedFilters, ...memberBaseFilter, ...baseFilters];

  const audienceInfiniteQuery = useAudienceInfiniteQuery({
    perPage: DEFAULT_PAGE_SIZE,
    order,
    query,
    initialPage,
    options: {
      keepPreviousData: false,
    },
    filters: finalFilters,
    scope,
    isAdminScope,
  });

  return {
    ...audienceInfiniteQuery,
    dataLength: audienceInfiniteQuery.totalQueryAudience,
    totalMembers: audienceInfiniteQuery.totalAudience,
    members: audienceInfiniteQuery.audience,
    isActiveQuery: !isEmpty(filters) || baseFilters.length > 0,
  };
};

export type UseSelectMembersInfiniteQueryV2 = ReturnType<
  typeof useSelectMembersInfiniteQueryV2
>;
